import { MenuOptionType } from "@dexteel/mesf-core";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { GridButtons } from "@/controls/buttons/GridButtons";
import { CatalogPaintCutType } from "@/shared/models/CatalogPaintCutType";
import { ColDef, ICellRendererParams } from "ag-grid-community";

type Props = {
	setSelectedRowData: (paintCutType: CatalogPaintCutType) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	showContextMenu: Function;
};

export const useTableData = ({
	setSelectedRowData,
	setShowModal,
	showContextMenu,
}: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "PaintCutTypeName",
			headerName: "Name",
			flex: 2,
			minWidth: 150,
		},
		{
			field: "-",
			cellRenderer: GridButtons,
			cellRendererParams: (params: ICellRendererParams) => ({
				setId: setSelectedRowData,
				id: params.data as CatalogPaintCutType,
				edit: true,
				setShowModal: setShowModal,
				showContextMenu: () =>
					showContextMenu(event, params.data, "paintCutTypesContext"),
			}),
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			headerName: "",
			sortable: false,
			flex: 1,
			maxWidth: 220,
			filter: false,
			autoHeaderHeight: true,
		},
	];

	const getMenuOptions = (data: CatalogPaintCutType) => {
		let options: MenuOptionType[] = [];

		options = options.concat([
			{
				name: "New Paint Cut Type",
				key: "new_paint_cut_type",
				onClick: () => {
					setShowModal("create");
				},
				icon: <PlaylistAddIcon />,
			},
		]);

		if (data) {
			options = options.concat([
				{
					name: "Edit Paint Cut Type",
					key: "edit_paint_cut_type",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("update");
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Paint Cut Type",
					key: "delete_paint_cut_type",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("delete");
					},
					icon: <DeleteIcon />,
				},
			]);
		}

		return options;
	};

	return { columnDefs, getMenuOptions };
};
